import * as Yup from "yup";
import { useFormik } from "formik";
import { sha256 } from "js-sha256";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef, Fragment } from "react";

import pages from "./../../../constants/pages";
import {
  TextField,
  LoadingButton,
  OTPInput,
  Loader,
  CaptchaDisplay,
  SelectField,
  Autocomplete,
} from "./../../../components";
import { useAlert, useAxiosV2, useAxios } from "./../../../hooks/";
import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { MdDocumentScanner } from "react-icons/md";
import AadharCardBack from ".././assests/AadharCard.svg";
import EditButton from ".././assests/edit.svg";
import VerificationPopup from "../../user step components/VerificationPopup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { getVisitorFaceData } from "../../../utils/getVisitorFaceData";
import { styled } from "@mui/material/styles";
import { HourglassEmpty } from "@mui/icons-material";

const OuterBox3 = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  background: "#ffffff",

  [theme.breakpoints.up("sm")]: {
    width: "100%", // full width for small devices
  },
  [theme.breakpoints.up("md")]: {
    width: "700px", // tablets
  },
  [theme.breakpoints.up("lg")]: {
    width: "900px", // laptops
  },
  [theme.breakpoints.up("xl")]: {
    width: "1100px", // large desktops
  },
}));

const MyComponent = ({
  visitorId,
  setVerificationFailedCount,
  numberOfInputs = 6,
  setVerification,
  setIdentityType,
  digipassDataKey,
  entityDetails,
  OuterBox2,
  OuterPaper,
  documentsList,
  handleIdentityTypeChange,
  selectDocuments,
  setSelectDocuments,
  errorUrlS,
}) => {
  const axios = useAxios();
  const inputRefs = useRef([]);
  const { alert } = useAlert();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [uuid, setUuid] = useState("");
  const [tranId, setTranId] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [errorStep, setErrorStep] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAadharNumber, setShowAadharNumber] = useState(false);
  const [aadharNumber, setAadharNumber] = useState("");
  const [aadharOtpGenerated, setAadharOtpGenerated] = useState(false);
  const [errorUrl, setErrorUrl] = useState(errorUrlS || "");

  const validationSchema = Yup.object().shape({
    aadhar_number: Yup.string()
      .required("Aadhaar Number is required")
      .matches(/^\d{12}$/, "Aadhaar Number must be exactly 12 digits"),
    captchaInput: Yup.string()
      .required("Aadhaar Captcha Input is required")
      .test("captchaMatch", "Captcha does not match", function (value) {
        return value === captcha;
      }),
  });

  const queryParams = new URLSearchParams(location.search);

  const popUp = queryParams.get("popup");
  const docFace = queryParams.get("doc_face");
  const entityId = queryParams.get("entity_id");
  const bookingId = queryParams.get("booking_id");
  const userTypeID = queryParams.get("user_type_id");
  const autoConsent = queryParams.get("auto_consent");
  const indepentent = queryParams.get("indepentent");
  const [stopStep, setStopStep] = useState(6);
  const digiLockerID = queryParams.get("id");
  const [errorMsg, setErrorMsg] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [disabledResendOTP, setDisabledResendOTP] = useState(false);

  const [isMasked, setIsMasked] = useState(true);
  const [aadhaarStack, setAadhaarStack] = useState([]);
  const [maskStack, setMaskStack] = useState([]);

  const handleResendOTP = () => {
    setDisabledResendOTP(true);
    setCountdown(60);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setDisabledResendOTP(false);
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleGoBack = () => {
    // setIdentityType("");
    // setVerification(KKKfalse);
    console.log("digiLockerID-errorUrl", errorUrl);

    digiLockerID ? navigate(errorUrl) : navigate(-1);
  };

  const handleOtpGoBack = () => {
    setOTP(new Array(numberOfInputs).fill(""));
    setAadharOtpGenerated(
      errorMsg ==
        "Wrong otp Entered please try with correct one..!(Wrong OTP Entered)"
        ? true
        : false
    );
  };

  const handleChange = (index, value) => {
    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);

    if (value !== "" && index < numberOfInputs - 1) {
      newOTP[index + 1] = "";
      setOTP(newOTP);
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && index > 0 && otp[index] === "") {
      const newOTP = [...otp];
      newOTP[index - 1] = "";
      setOTP(newOTP);
      inputRefs.current[index - 1].focus();
    }
  };

  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomCaptcha = "";
    for (let i = 0; i < 6; i++) {
      randomCaptcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(randomCaptcha);
  };

  function handleFirstOtp(values) {
    setOTP(new Array(numberOfInputs).fill(""));
    setLoading(true);
    axios({
      url: "/event/govt-api/send-aadhar-otp",
      method: "POST",
      data: {
        aadhar_number: values.aadhar_number,
      },
      disableRedirect: true,
    }).then((response) => {
      if (
        response?.data?.data?.code === "333" &&
        response?.data?.data?.message === "Too many requests"
      ) {
        dispatch(
          alert({
            type: "error",
            message: "Please try again in five minutes",
          })
        );
      }

      if (response.data?.response_code === 101) {
        setLoading(false);
        if (response.data?.data.response_status.code === "000") {
          dispatch(
            alert({
              type: "success",
              message: "OTP sent on the registered number.",
            })
          );

          setAadharOtpGenerated(true);
          const data = {
            visitor_id: visitorId,
            aadhar_otp_generated: 1,
            doc_type: "aadhar",
          };
          setUuid(
            response?.data?.data.response_data.uuid ||
              response?.data?.request_id
          );
          setTranId(response?.data?.data.response_data.tran_id);
        } else if (response?.data?.data.response_status.code === "471007") {
          dispatch(
            alert({
              type: "error",
              message: "Please enter a valid captcha.",
            })
          );
        } else if (
          response?.data?.data?.response_status?.code === "422005" ||
          response?.data?.data.response_status.code === "470046"
        ) {
          dispatch(
            alert({
              type: "error",
              message: response.data?.data?.response_status?.message,
            })
          );
        }

        if (response.data?.data?.response_status?.status === "FAIL") {
          dispatch(
            alert({
              type: "error",
              message: response.data?.data?.response_status?.message,
            })
          );
        }
      } else {
        setLoading(false);
        dispatch(
          alert({
            type: "error",
            message: "Error in sending OTP",
          })
        );
      }
    });
  }

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleVerifyOTP = () => {
    const otpString = otp.join("");
    const numericOtpString = otpString.replace(/\D/g, "");
    const numericOtp = parseInt(numericOtpString, 10);

    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });

    if (isNaN(numericOtp) || numericOtpString.length !== 6) {
      dispatch(
        alert({
          type: "error",
          message: "Invalid OTP. Please enter a 6-digit numeric code.",
        })
      );
      return;
    }
    setLoading(true);

    axios({
      url: "/event/govt-api/enter-aadhar-otp",
      method: "POST",
      data: {
        uuid: uuid,
        tran_id: tranId,
        otp: numericOtp.toString(),
        name: " ",
        visitor_id: visitorId,
        face_data: localStorage.getItem(faceData[0]),
        document_verification: true,
        is_encrypted_face: true,
        phone_number:
          visitorData.phoneNumber || sessionStorage.getItem("mobileNumber"),

        booking_id: bookingId,
        entity_id: entityId,
        user_type_id: userTypeID,
        auto_consent: autoConsent,
      },
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          if (autoConsent == "true") {
            setStopStep(5);
            axios({
              url: "event/visitor/save-consent",
              method: "POST",
              data: {
                visitor_id: visitorId,
                booking_id: bookingId,
                entity_id: entityId,
                user_type_id: userTypeID,
                face_data: response.data.encrypted_face_data,
                consent_for: ["face", "contact-details"],
              },
              disableRedirect: true,
            }).then((resp) => {
              if (resp.status) {
                const step = 1;
                setStopStep(6);
                if (step) {
                  let key = visitorId;
                  localStorage.setItem(
                    key,
                    response.data.encrypted_face_data || ""
                  );

                  setOpen(true);
                  setLoading(false);
                }
                setOpen(true);
                setLoading(false);
              }
            });
          } else {
            const step = 1;

            if (step) {
              let key = visitorId;
              localStorage.setItem(
                key,
                response.data.encrypted_face_data || ""
              );

              setOpen(true);
              setLoading(false);
            }
          }
        } else {
          if (response.data.step) {
            const msg =
              typeof response?.data?.data?.response_status?.message == "string"
                ? response?.data?.data?.response_status?.message
                : "";

            if (msg !== "Wrong OTP Entered") {
              setOpen(true);
              setErrorStep(response.data.step);

              setErrorUrl(response.data.next_url);
              setErrorMsg(
                response?.displayMessage?.message || response.displayMessage
              );
            }
          }

          setVerificationFailedCount((prevCount) => prevCount + 1);

          dispatch(
            alert({
              type: "error",
              message:
                response.data?.data?.response_status?.message ||
                response.data?.message?.displayMessage ||
                response?.displayMessage?.message ||
                response?.displayMessage,
            })
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        setVerificationFailedCount((prevCount) => prevCount + 1);
        console.log("error", error);
      });
  };

  const [otp, setOTP] = useState(new Array(numberOfInputs).fill(""));

  const onSubmit = async (values) => {
    try {
      handleFirstOtp(values);
    } catch (error) {
      dispatch(
        alert({
          type: "error",
          message: error,
        })
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      aadhar_number: "",
      captchaInput: "",
    },
    validationSchema,
    onSubmit,
  });

  const handleAadharNumberChange = (event) => {
    const adharString = event?.target?.value?.slice(-1);

    const key = adharString;
    let updatedAadhaar = [...aadhaarStack];
    let updatedMask = [...maskStack];

    if (event.target.value.length < updatedAadhaar.length) {
      // handle backspace
      updatedAadhaar.pop();
      updatedMask.pop();
    } else {
      const aadhaarLength = updatedAadhaar.filter((i) => i !== " ").length;

      if (aadhaarLength < 12 && !isNaN(key) && key !== " " && key !== null) {
        updatedAadhaar.push(key);
        updatedMask.push(aadhaarLength >= 8 ? key : "X");
      }
    }

    setAadhaarStack(updatedAadhaar);
    setMaskStack(updatedMask);

    const rawValue = updatedAadhaar.join("").replace(/\s/g, "");
    formik.setFieldValue("aadhar_number", rawValue);
  };

  const getDisplayValue = () => {
    return isMasked ? maskStack.join("") : aadhaarStack.join("");
  };

  const handleAadharPaste = (event) => {
    event.preventDefault();

    // Get only numbers from pasted text
    const pasteData = event.clipboardData.getData("text").replace(/\D/g, "");
    if (!pasteData) return;

    // Limit to 12 digits
    const cleanValue = pasteData.slice(0, 12);

    const updatedAadhaar = [];
    const updatedMask = [];

    for (let i = 0; i < cleanValue.length; i++) {
      // if (i > 0 && i % 4 === 0) {
      //   updatedAadhaar.push(" ");
      //   updatedMask.push(" ");
      // }
      updatedAadhaar.push(cleanValue[i]);
      updatedMask.push(i >= 8 ? cleanValue[i] : "X");
    }

    setAadhaarStack(updatedAadhaar);
    setMaskStack(updatedMask);
    formik.setFieldValue("aadhar_number", cleanValue);
  };

  // Helper to darken light colors
  const adjustColor = (hex) => {
    if (!hex) return "#c4c412";

    // Remove '#' if present
    hex = hex.replace("#", "");

    // Convert shorthand hex (like #fc0)
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((x) => x + x)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Check brightness
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // If too bright, darken it
    if (brightness > 180) {
      const darken = (val) => Math.max(0, val - 60);
      return `rgb(${darken(r)}, ${darken(g)}, ${darken(b)})`;
    }

    return `#${hex}`;
  };

  if (!aadharOtpGenerated) {
    return (
      <Fragment>
        <Grid item container>
          <Grid item container justifyContent={"center"}>
            <Grid
              item
              container
              md={12}
              sl={6}
              sx={{
                justifyContent: "start",
                alignContent: "start",
              }}
            >
              <OuterBox2>
                <OuterPaper style={{ padding: "0px" }} elevation={3}>
                  <div
                    style={{
                      // width: "95vw",
                      position: "relative",
                      height: "35vh",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sx={{
                        position: "relative",
                        zIndex: "999999",
                        top: "47%",
                        left: "2%",
                        width: "96.25%",
                      }}
                    >
                      <Typography
                        variant="h3"
                        fontWeight={900}
                        sx={{ marginTop: "7.5px" }}
                      >
                        {"Verify Profile Using Aadhaar"}
                      </Typography>

                      <Typography
                        variant="body1"
                        fontWeight={500}
                        sx={{ marginTop: "7.5px", color: "#00000099" }}
                      >
                        {`Please enter your Aadhaar details to verify your profile.`}
                      </Typography>

                      <TextField
                        select
                        size="small"
                        style={{ marginTop: "10px", background: "white" }}
                        value={selectDocuments}
                        onChange={(e) => {
                          setSelectDocuments(e.target.value);
                          handleIdentityTypeChange(e.target.value);
                        }}
                      >
                        {documentsList?.map((item, index) => (
                          <MenuItem key={item.id} value={item._id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>

                      {documentsList?.filter(
                        (item) => item?.document_id == 1
                      )[0]?.display && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                            mt: 2,
                            backgroundColor: documentsList?.filter(
                              (item) => item?.document_id == 1
                            )[0]?.color,
                            color: "#060606ff", // dark gold text
                            padding: "8px 14px",
                            borderRadius: "4px",
                            borderLeft: `4px solid ${adjustColor(
                              documentsList.filter(
                                (item) => item?.document_id == 1
                              )[0]?.color
                            )}`, // light yellow left bar
                            // width: "",
                            boxShadow: `0 0 0 1px ${
                              documentsList.filter(
                                (item) => item?.document_id == 1
                              )[0]?.color
                            } inset`, // subtle border like in screenshot
                          }}
                        >
                          <HourglassEmpty sx={{ fontSize: 18 }} />
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 500,
                            }}
                          >
                            {
                              documentsList.filter(
                                (item) => item?.document_id == 1
                              )[0]?.message_note
                            }
                          </Typography>
                        </Box>
                      )}
                    </Grid>

                    <img
                      style={{
                        height: "35vh",
                        position: "absolute",
                        top: "0px",
                      }}
                      src={AadharCardBack}
                    />
                  </div>
                </OuterPaper>
              </OuterBox2>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          container
          mt={
            documentsList?.filter((item) => item?.document_id == 1)[0]?.display
              ? 7.5
              : 0
          }
        >
          <Grid item container justifyContent={"center"}>
            <Grid
              item
              container
              md={12}
              sl={6}
              sx={{
                justifyContent: "start",
                alignContent: "start",
              }}
            >
              <OuterBox3>
                <OuterPaper style={{ padding: "0px" }} elevation={3}>
                  <Grid item padding={"2%"} alignContent={"center"}>
                    <form>
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: "700", marginBottom: "17.5px" }}
                      >
                        Enter Aadhaar Number
                        <span
                          style={{
                            color: "red",
                            fontWeight: "700",
                          }}
                        >
                          *
                        </span>
                      </Typography>

                      {/* <TextField
                        fullWidth
                        sx={{ marginBottom: "16px" }}
                        variant="outlined"
                        // label={
                        //   <Fragment>
                        //     <Grid container>
                        //       <Grid item xs={10}>
                        //         Enter 12 Digit Aadhar Number
                        //       </Grid>
                        //     </Grid>
                        //   </Fragment>
                        // }
                        placeholder={"Enter 12 Digit Aadhaar Number"}
                        name="aadhar_number"
                        value={formik.values.aadhar_number}
                        onChange={handleAadharNumberChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.aadhar_number &&
                          Boolean(formik.errors.aadhar_number)
                        }
                        InputProps={{
                          endAdornment: (
                            <Fragment>
                              <Tooltip title="Upload Document">
                                <input
                                  accept="image/*,application/pdf"
                                  style={{ display: "none" }}
                                  id="file-upload"
                                  type="file"
                                  onChange={(event) => {
                                    const fil = event.target.files[0];
                                    setOCRLoading(true);
                                    const data = new FormData();
                                    data.append("file", fil);
                                    axios({
                                      url: "event/govt-api/ocr",
                                      method: "POST",
                                      data: data,
                                    }).then((response) => {
                                      formik.setFieldValue(
                                        "aadhar_number",
                                        response.data?.data?.number || ""
                                      );

                                      setOCRLoading(false);
                                      if (!response.data?.data?.number) {
                                        dispatch(
                                          alert({
                                            type: "error",
                                            message:
                                              "Please share the right documents",
                                          })
                                        );
                                      }
                                    });
                                  }}
                                />
                                <label htmlFor="file-upload">
                                  {!ocrLoading ? (
                                    <MdDocumentScanner
                                      style={{
                                        color: "#3936EF",
                                        fontSize: "35px",
                                        background: "white",
                                        borderRadius: "7px",
                                        padding: "3px 5px",
                                        width: "100%",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <CircularProgress
                                      sx={{
                                        color: "#3936EF",
                                        fontSize: "35px",
                                      }}
                                    />
                                  )}
                                </label>
                              </Tooltip>
                            </Fragment>
                          ),
                        }}
                      /> */}

                      <TextField
                        size="small"
                        fullWidth
                        sx={{ marginBottom: "16px" }}
                        variant="outlined"
                        placeholder="Enter 12 Digit Aadhaar Number"
                        name="aadhar_number"
                        value={getDisplayValue()}
                        onChange={handleAadharNumberChange}
                        onBlur={formik.handleBlur}
                        onPaste={handleAadharPaste}
                        error={
                          formik.touched.aadhar_number &&
                          Boolean(formik.errors.aadhar_number)
                        }
                        helperText={
                          formik.touched.aadhar_number &&
                          formik.errors.aadhar_number
                        }
                        InputProps={{
                          endAdornment: (
                            <Fragment>
                              <Tooltip>
                                <input
                                  accept="image/*,application/pdf"
                                  style={{ display: "none" }}
                                  id="file-upload"
                                  type="file"
                                  // onChange={(event) => {
                                  //   const fil = event.target.files[0];
                                  //   setOCRLoading(true);
                                  //   const data = new FormData();
                                  //   data.append("file", fil);
                                  //   axios({
                                  //     url: "event/govt-api/ocr",
                                  //     method: "POST",
                                  //     data: data,
                                  //   }).then((response) => {
                                  //     formik.setFieldValue(
                                  //       "aadhar_number",
                                  //       response.data?.data?.number || ""
                                  //     );
                                  //     setOCRLoading(false);
                                  //     if (!response.data?.data?.number) {
                                  //       dispatch(
                                  //         alert({
                                  //           type: "error",
                                  //           message:
                                  //             "Please share the right documents",
                                  //         })
                                  //       );
                                  //     }
                                  //   });
                                  // }}
                                />
                                <label>
                                  {isMasked ? (
                                    <VisibilityIcon
                                      style={{
                                        color: "#3936EF",
                                        fontSize: "35px",
                                        background: "white",
                                        borderRadius: "7px",
                                        padding: "3px 5px",
                                        width: "100%",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setIsMasked(false);
                                      }}
                                    />
                                  ) : (
                                    <VisibilityOffIcon
                                      sx={{
                                        color: "#3936EF",
                                        fontSize: "35px",
                                        background: "white",
                                        borderRadius: "7px",
                                        padding: "3px 5px",
                                        width: "100%",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setIsMasked(true);
                                      }}
                                    />
                                  )}
                                </label>
                              </Tooltip>
                            </Fragment>
                          ),
                        }}
                      />
                      <Grid container>
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ fontWeight: "700" }}>
                            Enter Captcha
                            <span
                              style={{
                                color: "red",
                                fontWeight: "700",
                              }}
                            >
                              *
                            </span>
                          </Typography>
                        </Grid>

                        <Grid container sx={{}}>
                          <Grid xs={7} sx={{ alignSelf: "end" }}>
                            <TextField
                              size="small"
                              margin="normal"
                              variant="outlined"
                              placeholder="Enter Captcha"
                              name="captchaInput"
                              value={formik.values.captchaInput}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.captchaInput &&
                                Boolean(formik.errors.captchaInput)
                              }
                              helperText={formik.errors.captchaInput}
                              inputProps={{
                                maxLength: 6,
                              }}
                              autoComplete="off"
                            />
                          </Grid>

                          <Grid
                            xs={5}
                            sx={{ alignSelf: "start", padding: "0px 15px" }}
                          >
                            <CaptchaDisplay
                              captcha={captcha}
                              generateCaptcha={generateCaptcha}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container sx={{ marginTop: "35px" }}>
                        <LoadingButton
                          loading={loading}
                          onClick={formik.handleSubmit}
                          disabled={!formik.isValid || !formik.dirty}
                          style={{ marginBottom: "15px" }}
                        >
                          Send OTP
                        </LoadingButton>

                        <LoadingButton
                          onClick={handleGoBack}
                          backgroundColor="#F5F0E5"
                          style={{ color: "black" }}
                        >
                          Back
                        </LoadingButton>
                      </Grid>
                    </form>
                  </Grid>
                </OuterPaper>
              </OuterBox3>
            </Grid>
          </Grid>
        </Grid>
      </Fragment>
    );
  }

  const handlePaste = (event, index) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData("text").replace(/\D/g, ""); // only numbers
    if (!pasteData) return;

    const newOtp = [...otp];
    for (let i = 0; i < numberOfInputs && i < pasteData.length; i++) {
      newOtp[index + i] = pasteData[i];
      if (inputRefs.current[index + i]) {
        inputRefs.current[index + i].value = pasteData[i];
      }
    }
    setOTP(newOtp);

    // Focus the next empty input
    const nextIndex = index + pasteData.length;
    if (nextIndex < numberOfInputs && inputRefs.current[nextIndex]) {
      inputRefs.current[nextIndex].focus();
    }
  };

  return (
    <Loader>
      <Grid item container>
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox2 style={{ width: "100%" }}>
              <OuterPaper style={{ padding: "0px" }} elevation={3}>
                <div
                  style={{
                    width: "100%",
                    position: "relative",
                    height: "35vh",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      position: "relative",
                      zIndex: "999999",
                      top: "47%",
                      left: "3%",
                    }}
                  >
                    <Typography
                      variant="h3"
                      fontWeight={900}
                      sx={{ marginTop: "7.5px" }}
                    >
                      {"Enter OTP "}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight={500}
                      sx={{
                        marginTop: "7.5px",
                        color: "#00000099",
                      }}
                    >
                      {"Sent to mobile number linked with Aadhaar number "}
                      <span style={{ fontWeight: 900, color: "rgb(0, 0, 0)" }}>
                        {" "}
                        {`${maskStack.join("")}`}
                        <img
                          src={EditButton}
                          width="25px"
                          height="25px"
                          onClick={handleOtpGoBack}
                          style={{ verticalAlign: "bottom" }}
                        ></img>
                      </span>
                    </Typography>
                  </Grid>
                  <img
                    style={{
                      height: "35vh",
                      position: "absolute",
                      top: "0px",
                    }}
                    src={AadharCardBack}
                  />
                </div>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
      </Grid>

      <Grid item container>
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox2>
              <OuterPaper style={{ padding: "0px" }} elevation={3}>
                <Grid item padding={"15px"}>
                  <form>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        marginTop: "20px",
                      }}
                    >
                      {otp.map((value, index) => (
                        <OTPInput
                          key={index}
                          index={index}
                          value={value}
                          otp={otp}
                          inputRefs={inputRefs}
                          otpLength={numberOfInputs}
                          onChange={(e) => handleChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          onPasteOTP={(e) => handlePaste(e, index)}
                        />
                      ))}
                    </div>

                    <Grid
                      container
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <Grid item container xs={12} mb={2}>
                        <Typography
                          variant="body2"
                          sx={{ paddingRight: "6px", marginTop: "17.5px" }}
                        >
                          {disabledResendOTP ? (
                            ` Resend OTP in (${countdown}s)`
                          ) : (
                            <Fragment>
                              Didn’t Receive OTP yet?&nbsp;&nbsp;{" "}
                              <span
                                style={{
                                  color: "#3936EF",
                                  fontWeight: "bolder !important",
                                }}
                                onClick={() => {
                                  formik.handleSubmit();
                                  handleResendOTP();
                                }}
                              >
                                Resend again.
                              </span>
                            </Fragment>
                          )}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container mt={22.5}>
                      <LoadingButton
                        loading={loading}
                        onClick={handleVerifyOTP}
                        disabled={!formik.isValid || !formik.dirty}
                        style={{ margin: "10px 0px" }}
                      >
                        Verify Aadhaar
                      </LoadingButton>

                      <LoadingButton
                        onClick={() => {
                          window.location.reload();
                          // handleOtpGoBack
                        }}
                        backgroundColor="#F5F0E5"
                        style={{ color: "black" }}
                      >
                        Back
                      </LoadingButton>
                    </Grid>
                  </form>
                </Grid>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
        {console.log(stopStep, "digiLock !digiLockerIDerID", errorStep)}
        <VerificationPopup
          open={open}
          startStep={0}
          stopStep={stopStep}
          errorStep={errorStep}
          errorMsg={errorMsg}
          onClose={() => {
            setOpen(false);
            setErrorStep(null);
            !digiLockerID && setErrorUrl("");
            setStopStep(6);
            handleOtpGoBack();
            if (errorStep != null) {
              navigate(errorUrl);
            } else if (popUp) {
            } else if (bookingId == -1 && docFace == "true") {
              navigate(
                `${pages.EventSuccess.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}`
              );
            } else if (bookingId == -1) {
              navigate(pages.Profile.route);
            } else {
              if (errorStep != null) {
              } else if (popUp) {
                localStorage.setItem("windowClosed", true);
                window.close();
              } else if (userTypeID == 1) {
                navigate(
                  `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}`
                );
              } else if (
                userTypeID == 3 ||
                userTypeID == 4 ||
                userTypeID == 6 ||
                userTypeID == 8
              ) {
                navigate(
                  `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
                );
              } else if (userTypeID == 2) {
                navigate(
                  `${
                    indepentent
                      ? pages.IndependentAppointmentSummary.route
                      : pages.AppointmentSummary.route
                  }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
                );
              } else if (userTypeID == 5) {
                navigate(
                  `${pages.HotelSummary.path}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
                );
              }
            }
          }}
        />
      </Grid>
    </Loader>
  );
};

export default MyComponent;
